import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { UniversalLink } from '@plone/volto/components';
import { RichTextSection } from 'design-comuni-plone-theme/components/ItaliaTheme/View';

const messages = defineMessages({
  web_contacts: {
    id: 'web_contacts',
    defaultMessage: 'Recapiti web',
  },
});

const IndirizzoRecapitiWeb = ({ content }) => {
  const intl = useIntl();
  return (
    <>
      {content.recapiti_web.length > 0 && (
        <RichTextSection
          tag_id="web_contacts"
          title={intl.formatMessage(messages.web_contacts)}
        >
          {content.recapiti_web.map((contact) => (
            <div className="d-flex">
              <div className="label me-2 fw-bold">{contact.label}: </div>
              <div className="value">
                <UniversalLink href={contact.value}>
                  {contact.value}
                </UniversalLink>
              </div>
            </div>
          ))}
        </RichTextSection>
      )}
    </>
  );
};

export default IndirizzoRecapitiWeb;
